import { memo, useCallback, useMemo } from 'react'
import { Seo } from 'components'

import OrderYarcheCreatePage from '../OrderYarcheCreatePage/OrderYarcheCreatePage'

export const OrderYarcheRedirectPage = memo(() => {
  const data = useMemo(() => {
    const orderFormData = sessionStorage.getItem('orderYarcheFormData')

    return orderFormData ? JSON.parse(orderFormData) : null
  }, [])

  const handleSuccess = useCallback(() => {
    sessionStorage.removeItem('orderYarcheFormData')
  }, [])

  return (
    <>
      <Seo
        description="Создание новой заявки для размещения в сервисе доставки сборных грузов QP5 Express. Заполнение данных о грузе и предварительный расчет стоимости грузоперевозки."
        title="Новая заявка – сборные перевозки QP5 Express"
      />
      <OrderYarcheCreatePage initialValues={data} onFailure={handleSuccess} onSuccess={handleSuccess} />
    </>
  )
})
